import React from 'react';
import { useEffect, useState, useRef } from "react";
import { LANGTYPE_EN, useLanguage } from '@/app/utils/LanguageContext';
import { useMyContext } from '@/app/utils/MyContext';
import "@/app/style/expertColumnM.scss";
import { getSearchParams, generateAdobeDataRaceNo, generateAdobeDataHorseName, adobeData, useViewTracker } from '@/app/utils/Common';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import _ from 'lodash';
import Disclaimer from "@/app/ui/Disclaimer";
import betslip from "./betslip.json";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { getDisclaimer } from "@/app/utils/request/requestList";
import { GET_DISCLAIMER} from '@/app/utils/request/query';
import { formattedDate } from "@/app/utils/DayJS"; 

import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Stack from '@mui/material/Stack';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ExpertColumnM = (props: any) => {
    const { betTypeList, commentary, horseList, trackAnalysisExperts, expertName, expertNameEn, menuTab, pmPoolsData } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [expertHorseData, setExpertHorseData] = useState<any>([]);
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
    const [isMore, setIsMore] = useState<boolean>(false);
    const [isExpand, setIsExpand] = useState<boolean>(false);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dialogType, setDialogType] = useState<string>("");
    const [showMore, setShowMore] = useState<boolean>(true);
    const openWin = useRef(null);
    const [disclaimerData, setDisclaimerData] = React.useState('');
    const [showAddSlipAlert, setShowAddSlipAlert] = useState<boolean>(false);

    const OneBSwitch = window.globalConfig?.OneBSwitch;
    const TwoASwitch = window.globalConfig?.TwoASwitch;
 
    const betShareRef = useRef<any>(null);
    const [alerts, setAlerts] = useState<any>([]); 

    useEffect(() => {
        const loadSdk = async () => { 
          const dynamicImport = new Function(
            "url",
            "return import(url)"
          ) as (url: string) => Promise<any>;
     
          const sdk = await dynamicImport(window.globalConfig.BETSHARE.SDK);
          sdk.init({betShareBaseUrl: window.globalConfig.BETSHARE.DOMAIN, eWinBaseUrl: window?.globalConfig.DATA_SOURCES?.JCBW_DOMAIN});
          betShareRef.current = sdk.betShare; 
          console.log("sdk", sdk.betShare) 
        };
        if(TwoASwitch){ 
            loadSdk().catch(console.error);
        }
      }, []);

    const trakWA = () => {
        handleWA("ExpertPhoto")
    }
    const containsRef = useViewTracker(trakWA, 5000) as React.RefObject<HTMLDivElement>;

    const getBetSelection = (name: string, isName?: boolean) => {
        const match = name.match(/^(.*?)\s*[（(][^\d]*(\d+)[^）)]*[)）]/);
        if (isName) {
            //const match = name.match(/^(.*?)\s*\(/);
            return match ? match?.[1] : "";
        } else {
            //const match = name.match(/\((\d+)\s/);
            return match ? match?.[2] : "";
        }
    }

    console.log("data", betTypeList, betslip, horseList)

    const clickMore = () => {
        setIsMore(!isMore)
        handleWA(!isMore ? "More" : "Less")
        if (isMore) {
            const dom = document.getElementById("expertColumnM");
            dom?.scrollIntoView();
        }
    } 

    useEffect(() => {
        if(OneBSwitch){
            getDisclaimer({
                language: lang.langCode,
            }, GET_DISCLAIMER, "cms", false).then((res) => {
                setDisclaimerData(res?.item?.disclaimer?.value || '');
            });
        }
    }, [OneBSwitch])

    useEffect(() => {
        const commentaryContent = document.getElementById("commentaryContent")
        if (commentaryContent != null) {
            const comDom_scrollHeight = commentaryContent?.scrollHeight;
            const comDom_clientHeight = commentaryContent?.clientHeight;
            const lessthan4line = comDom_scrollHeight == comDom_clientHeight;

            console.log("comDom_clientHeight RacingInfo", comDom_clientHeight, comDom_scrollHeight)
            if((lessthan4line && comDom_clientHeight < 92)){
                setShowMore(false);
            }else if(Math.abs(comDom_scrollHeight - comDom_clientHeight) <= 3) {
                setShowMore(false);
            } else {
                setShowMore(true);
            }
        }
    }, [commentary, document.getElementById("commentaryContent")?.clientHeight])
 
    const sortHorserNum = (a: any) => {
        return Number(a?.horseNumber ?? 0)
    }
    const handleWAbyOnlyType = (type: string) => {
        handleWA(type, '', '', '', false, '', null);
    }
    const handleWAbyHorse = (type: string, horse?: string, isNeedHorse?: boolean, link?: string, e?: any) => {
        handleWA(type, '', '', horse, true, link, e);
    }

    const handleWAbyBet = (type: string, bettypeNo: string, buttonName?: string, link?: string, e?: any, betList?: any ) => {
        handleWA(type, bettypeNo, buttonName, '', false, link, e, betList);
    }

    const handleWA = async(type: string, bettypeNo?: string, buttonName?: string, horse?: string, isNeedHorse?: boolean, link?: string, e?: any, betList?: any) => {
        if (link && e) e.preventDefault();
        const pagename = menuTab === "raceCard" ? "Racecard-Expert" : "ExpertColumn";

        const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());

        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: type == "ExpertPhoto" ? `racing/simulcast_Display_Racecard-Expert` : `racing/simulcast_Click_${pagename}_${type}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: expertNameEn,
            bettype: buttonName || "",
            buttonName: buttonName ? `racing/simulcast_Click_${ bettypeNo }` : "",
            horse: !isNeedHorse ? "" : generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, horse),
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
        if(type == "AddSlip" && TwoASwitch){
            if(link){ 
                window.open(link);
            }else {
                const legs = betList?.map((x: any) => {
                    return({
                        raceNo: x?.raceNumber,
                        selections: buttonName == "D-T" ? x?.selections?.map((s: any) => s.horseNum.toString()) : x?.combination?.map((s: any) => s.horseNum.toString()),
                        bankers: buttonName == "D-T" ? x?.banker?.map((s: any) => s.horseNum.toString()) : []
                    })
                })
                console.log("sdk AddSlip", betShareRef, betList, legs);
                const pg = props?.menuTab === "raceCard" ? "Racecard-ExpertColumn" : "ExpertColumn";
        
                try{
                   
                await betShareRef?.current({ 
                    businessType: "HR",
                    betType: buttonName,
                    meetingDate: formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD"),
                    venue: myContextState?.selectedMeetingVenueCode,
                    legs: legs,
                    target: "ewin",
                    lang: lang.langCode == "en-us" ? 'en' : 'ch',
                    betslipMode: "append",
                    b_cid: `SPLDSP_racing/simulcast-${pagename}_AddSlip`,
                    sourceFrom: `HKJCweb_JCRW_Simulcast-${pg}_${props?.expertNameEn}_${myContextState.selectedMeeting?.countryNameEn}`,
                    // onWindowFocusError: (t: any)=>{  
                    //     setShowAddSlipAlert(true);   
                    // },
                    // onError: (errorCode: any) => { 
                    //     console.log("sdk error", errorCode)
                    //     setTimeout(() => {
                    //         alert(t(`expert_column_alert_error_${errorCode}`))
                    //     }, 500);
                    // }
                }) 
                console.log("sdk success") 
                //setShowAddSlipAlert(true); 
                addAlert() 
                }catch(error: any){
                    console.log("sdk error", error) 
                    setTimeout(() => {
                        alert(t(`expert_column_alert_error_${error?.errorCode ?? 500}`))
                    }, 500);
                } 
            }
        }else if(link){ 
            // const target = e.currentTarget.getAttribute("target") || "_self";
            //const path = `${link}${["AddSlip"].includes(type)  ? `&b_cid=SPLDSP_racing/simulcast-${pagename}_${type}` : ''} `;
            window.open(link) 
            // openInNewTab(link)
        }   
    }
    const addAlert = () => { 
        const id = Date.now() + Math.random();
        const alert = { 
            id, 
            message: `Alert ${alerts.length + 1}`
            };   
        setAlerts((prev: any[]) => [...prev, alert])
        setTimeout(() => { 
            setAlerts((prev: any[]) =>prev.filter(item => item.id !== id));
        }, 3000); 
    };

    const pmPoolStatusByStart = (oddsType: string, bet: any) => {
        const raceNo = _.orderBy(bet, ["raceNumber"], ["asc"])?.[0]?.raceNumber;
        const type = oddsType === "D-T" ? "DT" : oddsType;
        const pm = pmPoolsData?.pmPools?.filter((x: any) => x.oddsType == type && x?.leg?.races?.[0] == raceNo);

        console.log("pmPoolStatusByStart", pm, oddsType, raceNo)
        return pm ? (pm?.[0]?.sellStatus === "START_SELL" && pm?.[0]?.status == "START_SELL") : false
    } 
    const expertColumnDialog = () => {
        return (
            <Dialog
                className='expertColumnDialog'
                open={openDialog}
                keepMounted
                fullWidth
                TransitionComponent={Transition}
                sx={{
                    '& .MuiModal-backdrop': {
                        zIndex: 0,
                        position: 'absolute'
                    },
                    '& .MuiDialog-container': {
                        alignItems: 'flex-end',
                        ' .MuiPaper-root': {
                            zIndex: 1
                        }
                    },
                    '& .MuiPaper-root': {
                        maxWidth: 'unset',
                        width: '100%',
                        margin: 0,
                        borderRadius: '12px 12px 0 0',
                    } 
                }}
                onClose={() => { setOpenDialog(false) }}
            >
                <DialogTitle className='dialogTit' id="customized-dialog-title">
                    { dialogType == "disclaimer" ? t("expert_column_disclaimer") : trackAnalysisExperts?.expertName?.value}
                </DialogTitle >
                <IconButton
                    className='dialogClose'
                    aria-label="close"
                    onClick={() => { setOpenDialog(false) }}
                >
                    <CloseIcon />
                </IconButton> 
                <DialogContent className='dialogcontent'>
                    {
                        dialogType == "disclaimer" ? <Disclaimer disclaimerData={disclaimerData} hideTitle={true} fontSize={13} /> :
                        <div dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}></div>
                    }
                    
                </DialogContent>
            </Dialog>

        )
    }

    return (
        <div className={menuTab == "refInfo" ? 'refInfo expertColumnM' : 'expertColumnM'} id="expertColumnM">
            {/* {
                menuTab =="refInfo" ? 
                <div className='cMkiTs' >
                    {t('expert_column')}
                    {menuTab =="refInfo" ? null : <img src='/expand.png' onClick={clickExpand} className={isExpand ? "expand" : ""} />} 
                </div>
                : null
            } */}
            <div className='expertColumn-body'>
                <div className='expertColumn-info'>
                    <div className='info dis_flex'>
                        <p className='pic' ref={menuTab == "raceCard" ? containsRef : null}>
                            <img src={trackAnalysisExperts?.expertPicture?.src} alt={trackAnalysisExperts?.expertPicture?.alt} />
                        </p>
                        {
                            expertName ?
                                <>
                                    {trackAnalysisExperts?.expertName?.value}
                                    <i className='info-icon' onClick={() => { setOpenDialog(true); setDialogType("Info"); handleWAbyOnlyType("Info"); }}><img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} /></i>
                                </> : null
                        }

                    </div>
                    {horseList?.length || betTypeList?.length ?
                        <div className='selections'>
                            <p>{t("expert_column_selection_title")}</p>
                            <div>
                                {horseList?.length > 0 && horseList?.map((item: any, num: number) =>
                                    <div key={num}>
                                        <img src={`${myContextState.assetPrefix}/commonImg/horse_selection.svg`} />
                                        <a onClick={(e) => { handleWAbyHorse("HorseProfile", item.horseName, true, item.link, e); }} href={item.link || 'javascript:;'} target={item.link && "_blank"} style={{ cursor: item.link ? "pointer" : "default" }}>
                                            {`${item.horseNumber}. ${item.horseName}`}
                                        </a>
                                    </div>
                                )}

                            </div>
                        </div>
                        : null}

                    <div className='content'>
                        <div id='commentaryContent' className={`text-box ${isMore || betTypeList?.length == 0 ? "show-more" : ""}`} >
                            <p dangerouslySetInnerHTML={{ __html: commentary }}></p> 
                            {
                                !OneBSwitch && 
                                <div className='disclaimer'> 
                                    <Disclaimer /> 
                                </div>
                            }
                        </div>

                        {betTypeList?.length == 0 || !showMore ? null :
                            <p className={`btn-More ${isMore ? "ck-more" : ""}`} onClick={clickMore}>
                                {isMore ? t("expert_column_show_less") : t("expert_column_show_more")}
                                {/* <img src='/footer/arrow-up.svg'></img> */}
                                <KeyboardArrowUpIcon />
                            </p>
                        }
                    </div>
                </div>

                {betTypeList?.length > 0 &&
                    <div className='betWrapper1'>
                        {
                            betTypeList?.map((betItem: any, idx: number) =>
                                <div key={idx}>
                                    <p className='tit'>
                                        <a onClick={(e) => handleWAbyBet("BetType", '', '', betItem?.link, e)} href={betItem.link || 'javascript:;'} target={betItem.link && "_blank"} style={{ cursor: betItem.link ? "pointer" : "default" }}>
                                            {getBetSelection(betItem?.title, true)}
                                        </a>
                                    </p>
                                    {
                                        betItem?.betList?.bet?.map((row: any, i: number) => (
                                            <div key={i} className={betItem?.betList?.betType == "D-T" ? "selections" : "bet"}>
                                                {

                                                    betItem?.betList?.betType == "D-T" ? <>
                                                        {
                                                            (row?.banker && row?.banker?.length > 0) &&
                                                            <p>
                                                                <span>{`${row?.venueCode}-${row?.raceNumber}`}</span>
                                                                <span className='sty1'>{t("expert_banker")}</span>

                                                            </p>
                                                        }
                                                        {
                                                            row?.banker?.map((item: any, num: number) =>
                                                                <p key={num}><span></span><span>{`${item?.horseNum}. ${item?.horseName}`}</span></p>)
                                                        }
                                                        {
                                                            row?.selections?.length > 0 && <>
                                                                {
                                                                    (row?.banker && row?.banker?.length > 0) ?
                                                                        <p><span></span><span className='sty1 sel'>{t("expert_sel")}</span></p>
                                                                        :
                                                                        <p>
                                                                            <span>{`${row?.venueCode}-${row?.raceNumber}`}</span>
                                                                            <span className='sty1'>{t("expert_sel")}</span>
                                                                        </p>
                                                                }

                                                                {
                                                                    row?.selections?.map((item: any, num: number) =>
                                                                        <p key={num}><span></span><span>{`${item?.horseNum}. ${item?.horseName}`}</span></p>)
                                                                }
                                                            </>
                                                        }
                                                    </> :
                                                        <>
                                                            <div>{`${row?.venueCode}-${row?.raceNumber} ${row?.type}`} </div>
                                                            <div>
                                                                {
                                                                    row?.combination?.map((item: any, num: number) =>
                                                                        <p key={num}><span></span><span>{`${item?.horseNum}. ${item?.horseName}`}</span></p>)
                                                                }
                                                            </div>
                                                        </>
                                                }

                                            </div>
                                        ))
                                    }

                                    <p className='btn-betslip'>
                                        <span onClick={(e) => handleWAbyBet("AddSlip", getBetSelection(betItem?.title, false), betItem?.betList?.betType, betItem?.betslipLink, e, betItem?.betList?.bet)}>{t("expert_total_no_of_bets").replace("{0}", getBetSelection(betItem?.title, false))}</span>

                                        {
                                            TwoASwitch ? 
                                            <span style={{ background: !(pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? "#fff" : "" }}
                                            >
                                                {(pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? <a onClick={(e) => handleWAbyBet("AddSlip", getBetSelection(betItem?.title, false), betItem?.betList?.betType, betItem?.betslipLink, e, betItem?.betList?.bet)} href={betItem?.betslipLink || 'javascript:;'} target={betItem?.betslipLink && "_blank"} style={{ cursor: pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default" }}>
                                                    {t("add_to_betslip")}
                                                </a> : null} 
                                            </span>
                                            :
                                            <span style={{ background: !betItem?.betslipLink || !(pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? "#fff" : "" }}
                                            >
                                                {(betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? <a onClick={(e) => handleWAbyBet("AddSlip", getBetSelection(betItem?.title, false), betItem?.betList?.betType, betItem?.betslipLink, e)} href={betItem?.betslipLink || 'javascript:;'} target={betItem?.betslipLink && "_blank"} style={{ cursor: betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default" }}>
                                                    {t("add_to_betslip")}
                                                </a> : null} 
                                            </span> 

                                        }
                                    </p>
                                </div>
                            )}
                    </div>
                }

                { OneBSwitch &&
                    <div className='disclaimer r1b'>
                        <div>{t("expert_column_hardcode_msg")}</div>
                        <p onClick={() => { setOpenDialog(true); setDialogType("disclaimer"); handleWAbyOnlyType("Disclaimer"); }}>
                            <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} />
                            {t("expert_column_disclaimer")}
                        </p>
                    </div>
                }
            </div> 
            {/* <Collapse in={showAddSlipAlert} sx={{width: '100%', position: "fixed", bottom: '24px', left: 0, zIndex: '190'}}> */}
            <Stack sx={{width: '100%', position: "fixed", bottom: '24px', left: 0, zIndex: '190'}}>
            {
                alerts?.map((al: any)=>(
                <Slide 
                key={al?.id}
                direction="up"  
                in={true} 
                timeout={300}  
                >
                <Alert 
                    
                    severity="success" 
                    iconMapping={{
                        success: <img src={`${myContextState.assetPrefix}/commonImg/successIcon.png`} ></img>,
                    }} 
                    sx={{ mb: 2, 
                        padding: '0 12px',
                        margin: '10px 20px 0',
                        color: '#000000', 
                        alignItems: 'center',
                        fontSize: '13px',
                        fontWeight: '400',
                        backgroundColor: '#F4F4F4', 
                        borderRadius: '8px', 
                        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)'
                    }}
                    >
                        {t("expert_column_alert")}
                </Alert>
                </Slide>
                ))
            }
            </Stack>
            {/* </Collapse> */}
            {expertColumnDialog()}
        </div>
    )
}

export default ExpertColumnM;